'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CREDIT_CARD_FORM_FIELDS = exports.CREDIT_CARD_FORM_FIELDS = {
    // credit card valuues
    cardName: {
        name: 'cardName',
        type: 'text',
        required: true
    },
    number: {
        name: 'number',
        type: 'text',
        required: true
    },
    expiry: {
        name: 'expiry',
        type: 'text',
        required: true
    },
    cvc: {
        name: 'cvc',
        type: 'text',
        required: true
    },
    postcode: {
        name: 'postcode',
        type: 'text',
        required: true
    },

    // prefilled values
    cardBrand: {
        name: 'cardBrand',
        type: 'text'
    },
    cardPrefilled: {
        name: 'cardPrefilled',
        type: 'text'
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/creditCard/creditCardConstants.js
// module id = 1774
// module chunks = 0